module.exports = __webpack_public_path__ + "static/media/settings_language_blue.c8c412c6.svg";